<template>
  <nav
    class="navbar is-fixed-top"
    role="navigation"
    aria-label="main navigation"
  >
    <div class="navbar-brand">
      <div class="navbar-item">
        <img src="../assets/logo.jpeg" class="image is-64x64" />
      </div>
      <div class="navbar-item">
        <p class="heading">Detective Notes</p>
      </div>
      <div class="navbar-item">
        <Curtain />
      </div>
    </div>
  </nav>
</template>

<script>
import Curtain from './Curtain.vue';

export default {
  name: 'Navbar',
  components: {
    Curtain,
  },
};
</script>
